import eventTracking from './eventTracking';
import generateTrackingValue from './generateTrackingValue';

const integrations = [
  {
    name: 'iselect',
    regex: /iselect.com.au/,
    events: [ 'event81', 'event10' ],
    handler: (href) => {
      const search = href.substring(href.indexOf('?'), href.length);
      return {
        eVar150: decodeURI(search)
      };
    }
  }
];

const getLinkTrackingData = (href) => {
  if (href) {
    for (const item of integrations) {
      console.log(`integration match for ${ item.name }`, item);
      if (href.match(item.regex)) {
        return {
          events: item.events,
          data: item.handler(href)
        };
      }
    }
  }
  console.log('no href, or integration match - use default events', href);

  return {};
};


export default function linkTracking(envData, props, label, order = 1, options = {} ) {

  const {
    href = '',
    container = generateTrackingValue(props),
    metric
  } = options;

  const {
    events = (options.events || [ 'event10' ]),
    data = {}
  } = getLinkTrackingData(href);

  eventTracking({
    events,
    itm: {
      site: window.utag ? window.utag.data.net_site : null,
      section: window.utag ? window.utag.data.net_sec1 : null,
      container,
      label,
      order,
      contenttype: window.utag ? window.utag.data.net_content_type : null,
      pagename: window.utag ? window.utag.data.net_pn : null,
    },
    metric,
    ...data
  }, envData);
}
